import { UseFormReturn } from 'react-hook-form';
import { useLanguage } from '@/hooks/useLanguage';
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from '@/components/ui/form';
import { Checkbox } from '@/components/ui/checkbox';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { AlertCircle } from 'lucide-react';

interface ConsentStepProps {
  form: UseFormReturn<any>;
}

const ConsentStep = ({ form }: ConsentStepProps) => {
  const { t } = useLanguage();

  return (
    <div className="space-y-6">
      <div className="text-center mb-6">
        <h3 className="text-2xl font-bold mb-2">Terms & Consent</h3>
        <p className="text-muted-foreground">Please review and accept the terms below</p>
      </div>

      <Alert>
        <AlertCircle className="h-4 w-4" />
        <AlertDescription>
          <p className="font-semibold mb-2">Important Notice</p>
          <p className="text-sm">
            This consultation is non-refundable and costs $150. Submitting this form does not create an attorney-client relationship until a formal agreement is signed. Please bring all relevant documents to your consultation.
          </p>
        </AlertDescription>
      </Alert>

      <FormField
        control={form.control}
        name="consentNotifications"
        render={({ field }) => (
          <FormItem className="flex flex-row items-start space-x-3 space-y-0 rounded-md border p-4">
            <FormControl>
              <Checkbox
                checked={field.value}
                onCheckedChange={field.onChange}
              />
            </FormControl>
            <div className="space-y-1 leading-none">
              <FormLabel className="cursor-pointer">
                {t('booking.consentNotifications')}
              </FormLabel>
            </div>
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="consentTerms"
        render={({ field }) => (
          <FormItem className="flex flex-row items-start space-x-3 space-y-0 rounded-md border p-4">
            <FormControl>
              <Checkbox
                checked={field.value}
                onCheckedChange={field.onChange}
              />
            </FormControl>
            <div className="space-y-1 leading-none">
              <FormLabel className="cursor-pointer">
                {t('booking.consentTerms')}
              </FormLabel>
              <FormMessage />
            </div>
          </FormItem>
        )}
      />

      <div className="bg-muted p-4 rounded-lg">
        <p className="text-sm text-center text-muted-foreground">
          Por favor traiga todos sus documentos y sus preguntas para esta consulta.
          <br />
          Please bring all documents and be prepared with all your questions. This consultation is non-refundable.
        </p>
      </div>
    </div>
  );
};

export default ConsentStep;
